import * as React from "react";
import { IExplorerProperties, IDataEntityResponse, IColumnMap } from "../../models";
import { safe, removeKeyWhenFalse, filterColumnsCSV, isPrint } from "../../utils";
import { ExplorerTabContent } from '../ExplorerTabContent';
import { WatchlistButton } from "../WatchlistButton";
import { Disclaimer, PDFIconDownload, HistoricalDownload } from "../../assets/";
import { BackToTop } from "../../assets/BackToTop/BackToTop";
import { FundExplorerFooter } from "./";

// tslint:disable-next-line:variable-name
const FaAngleRight = require('react-icons/lib/fa/angle-right');
const styles = require('../FundPages/Fundpages.pcss');
const tabStyles = require('./FundExplorerTabs.pcss');
const backToTopstyles = require('./overrides/BackToTopoverride.pcss');

interface IProps {
	groupedRows: any[];
}

export class ExplorerTabDailyPrices extends React.Component<IProps & IExplorerProperties, {}>{
	constructor(props) {
		super(props);
	}

	getColumns(isPPL, csvDownload = false) {
		let { appParams, editWatchlist, watchlist, disclaimers, modals, toggleModal, funds } = this.props;
		let { productrange, region, clienttype } = appParams;
		let tooltipDefault = false;

		const isICAV = productrange === "ICAV";
		const hideValoren = region.toLowerCase() !== "ch" || productrange !== "OEIC";
		const hideWKN = region.toLowerCase() === "uk" || productrange !== "OEIC";
		const hideHistoricPrices = !isPPL;
		const hideDealingBasis = !isPPL;
		const hideFundName = true;
		const hideShareClass = isPPL;
		const hidePrice = isPPL;
		const hideChange = isPPL || isICAV;
		const hideChangePercent = isPPL;
		const hideYield = isPPL || isICAV;

		const TEMP_HIDE_DOCS = false;
		const hideFacsheet = isICAV && clienttype === "diw";
		const hideKiid = (productrange === "OEIC" && clienttype === "diw") || (productrange === "OEIC" && clienttype === "adv");
		const hideFundReview = (productrange === "OEIC" && clienttype === "pri") || (productrange === "OEIC" && clienttype === "cha") || (isICAV && clienttype === "diw");
		
		// Added regulatory check to hide yield for shareclasses
		let regulatoryFunds = ["DIV","EXYD","GLOD","CHAR"];

		if(typeof(funds) != 'undefined') {
			funds.values.filter((element) => {
				// Check for ISINs that fit into regulatory change
				if (regulatoryFunds.indexOf(element.clientCode) !== -1){
					element.shareClasses.forEach(function(isins) {
						isins.latestTimeseriesValues.prices.yield = '-';
					})
				}
			});
		}

		let columns: IColumnMap[] = [
			{
				headerKey: 'Fund Name',
				field: 'display',
				entity: "fund",
				type: 'string',
				viewRestriction: 'table',
				explicitHide: hideFundName,
				headerClassName: tabStyles.dailyHeader + ' ' + tabStyles.fundNameColumn,
				isCSV: true,
				className: tabStyles.fundNameRow
			},
			{
				/** PPL Shareclass value */
				headerKey: 'Share Class',
				field: 'properties.shareclass_name',
				type: 'string',
				viewRestriction: 'table',
				tooltip: safe(() => disclaimers["TODO"][0]["disclaimers"][0], tooltipDefault),
				explicitHide: !hideShareClass,
				isCSV: true,
				headerClassName: tabStyles.dailyHeader + ' ' + tabStyles.columnLeft,
				className: tabStyles.firstColumn
			},
			{
				/** OEIC/ICAV Shareclass value */
				headerKey: 'Share Class',
				field: 'properties.shareclass_display',
				type: 'string',
				viewRestriction: 'table',
				tooltip: safe(() => disclaimers["TODO"][0]["disclaimers"][0], tooltipDefault),
				explicitHide: hideShareClass,
				isCSV: true,
				headerClassName: tabStyles.dailyHeader + ' ' + tabStyles.columnLeft,
				className: tabStyles.firstColumn
			},
			{
				headerKey: 'Currency',
				field: 'properties.currency',
				tooltip: safe(() => disclaimers["TODO"][0]["disclaimers"][0], tooltipDefault),
				type: 'string',
				isCSV: true
			},
			{
				headerKey: 'Date',
				field: 'latestTimeseriesValues.prices.date',
				type: 'date',
				isCSV: true,
				headerClassName: tabStyles.dailyHeader + ' ' + tabStyles.dateColumn
			},
			{
				headerKey: 'Price',
				field: 'latestTimeseriesValues.prices.shareclass_price',
				type: 'number',
				precision: 2,
				isPropertyAssetClass: true,
				tooltip: safe(() => disclaimers["tooltip_price"][0]["disclaimers"][0], tooltipDefault),
				explicitHide: hidePrice,
				isCSV: true,
				headerClassName: tabStyles.dailyHeader + ' ' + tabStyles.columnRight,
				className: tabStyles.numberColumn
			},
			{
				headerKey: 'Bid / Offer Prices',
				fields: ['latestTimeseriesValues.prices.local_bid_price', 'latestTimeseriesValues.prices.local_offer_price'],
				fieldSeperator: " / ",
				type: 'number',
				isPropertyAssetClass: false,
				precision: 2,
				isCSV: true,
				explicitHide: isICAV || isPPL,
				tooltip: safe(() => disclaimers["tooltip_bid_offer_price"][0]["disclaimers"][0], tooltipDefault),
				headerClassName: tabStyles.dailyHeader + ' ' + tabStyles.columnRight,
				className: tabStyles.numberColumn
			},
			{
				headerKey: 'Bid',
				field: 'latestTimeseriesValues.prices.local_bid_price',
				fields: ['latestTimeseriesValues.prices.local_bid_price'],
				type: 'number',
				isPropertyAssetClass: false,
				precision: 2,
				isCSV: true,
				explicitHide: !isPPL,
				tooltip: safe(() => disclaimers["tooltip_bid_price"][0]["disclaimers"][0], tooltipDefault),
				headerClassName: tabStyles.dailyHeader + ' ' + tabStyles.columnRight,
				className: tabStyles.numberColumn
			},
			{
				headerKey: 'Offer Price',
				field: 'latestTimeseriesValues.prices.local_offer_price',
				fields: ['latestTimeseriesValues.prices.local_offer_price'],
				type: 'number',
				isPropertyAssetClass: false,
				precision: 2,
				isCSV: true,
				explicitHide: !isPPL,
				tooltip: safe(() => disclaimers["tooltip_offer_price"][0]["disclaimers"][0], tooltipDefault),
				headerClassName: tabStyles.dailyHeader + ' ' + tabStyles.columnRight,
				className: tabStyles.numberColumn
			},
			{
				headerKey: 'Change',
				field: 'latestTimeseriesValues.prices.absolute_price_change',
				type: 'number',
				precision: 2,
				isCSV: true,
				tooltip: safe(() => disclaimers["tooltip_change"][0]["disclaimers"][0], tooltipDefault),
				explicitHide: hideChange,
				headerClassName: tabStyles.dailyHeader + ' ' + tabStyles.columnRight,
				className: tabStyles.numberColumn + ' ' + tabStyles.changeColumn,
			},
			{
				headerKey: 'Change (%)',
				field: 'latestTimeseriesValues.prices.percentage_price_change',
				type: 'number',
				precision: 2,
				appendPercentage: true,
				isCSV: true,
				tooltip: safe(() => disclaimers["tooltip_change_%"][0]["disclaimers"][0], tooltipDefault),
				explicitHide: hideChangePercent,
				headerClassName: tabStyles.dailyHeader + ' ' + tabStyles.columnRight,
				className: tabStyles.numberColumn
			},
			{
				headerKey: 'Yield (%)',
				field: 'latestTimeseriesValues.prices.yield',
				type: 'number',
				appendPercentage: true,
				precision: 2,
				isCSV: true,
				tooltip: safe(() => disclaimers["tooltip_yield"][0]["disclaimers"][0], tooltipDefault),
				explicitHide: hideYield,
				headerClassName: tabStyles.dailyHeader + ' ' + tabStyles.columnRight,
				className: tabStyles.numberColumn
			},
			{
				headerKey: 'Dealing Basis',
				field: 'latestTimeseriesValues.prices.dealing_price_basis',
				type: 'string',
				isCSV: true,
				tooltip: safe(() => disclaimers["TODO"][0]["disclaimers"][0], tooltipDefault),
				explicitHide: hideDealingBasis,
				headerClassName: tabStyles.dailyHeader + ' ' + tabStyles.columnRight,
			},
			{
				headerKey: 'ISIN',
				field: 'properties.isin',
				type: 'string',
				isCSV: true,
				tooltip: safe(() => disclaimers["tooltip_isin"][0]["disclaimers"][0], tooltipDefault),
				headerClassName: tabStyles.dailyHeader + ' ' + tabStyles.isinColumn
			},
			{
				headerKey: 'WKN',
				field: 'properties.wkn',
				type: 'string',
				isCSV: true,
				tooltip: safe(() => disclaimers["TODO"][0]["disclaimers"][0], tooltipDefault),
				explicitHide: hideWKN,
				headerClassName: tabStyles.dailyHeader + ' ' + tabStyles.columnRight,
			},
			{
				headerKey: 'Valoren',
				field: 'properties.valoren',
				type: 'string',
				isCSV: true,
				tooltip: safe(() => disclaimers["TODO"][0]["disclaimers"][0], tooltipDefault),
				explicitHide: hideValoren,
				headerClassName: tabStyles.dailyHeader + ' ' + tabStyles.columnRight,
			},
			{
				headerKey: 'Historic Prices',
				type: 'component',
				component: <HistoricalDownload appParams={appParams} modals={modals} toggleModal={toggleModal} />,
				explicitHide: hideHistoricPrices,
				headerClassName: tabStyles.dailyHeader + ' ' + tabStyles.columnRight,
				getPropsFn: (row, groupedRow) => {
					return {
						shareClass: row
					};
				},
				displayLimitation: "web"

			},
			{
				headerKey: 'Factsheet',
				type: 'component',
				component: <PDFIconDownload appParams={appParams} type="MR" />,
				getPropsFn: (row, groupedRow) => {
					return {
						documents: row.documents,
						row: row
					};
				},
				displayLimitation: "web",
				explicitHide: TEMP_HIDE_DOCS || hideFacsheet,
				headerClassName: tabStyles.dailyHeader + ' ' + tabStyles.columnRight,
				className: tabStyles.columnFactSheet
			},
			{
				headerKey: 'KIID',
				type: 'component',
				component: <PDFIconDownload appParams={appParams} type="KID" />,
				getPropsFn: (row, groupedRow) => {
					return {
						documents: row.documents,
						row: row
					};
				},
				displayLimitation: "web",
				explicitHide: TEMP_HIDE_DOCS || isPPL || hideKiid,
				headerClassName: tabStyles.dailyHeader + ' ' + tabStyles.columnRight,
			},
			{
				headerKey: 'Monthly Fund Review',
				type: 'component',
				component: <PDFIconDownload appParams={appParams} type="MC" />,
				getPropsFn: (row, groupedRow) => {
					return {
						documents: row.documents,
						row: row
					};
				},
				displayLimitation: "web",
				explicitHide: TEMP_HIDE_DOCS || isPPL || hideFundReview,
				headerClassName: tabStyles.dailyHeader + ' ' + tabStyles.columnRight,
			},
			{
				headerKey: 'Fund Profile',
				type: 'component',
				component: <PDFIconDownload appParams={appParams} type="FP" />,
				getPropsFn: (row, groupedRow) => {
					return {
						documents: row.documents,
						row: row
					};
				},
				displayLimitation: "web",
				explicitHide: TEMP_HIDE_DOCS || !isPPL
			},
			{
				headerKey: 'Quarterly Fund Review',
				type: 'component',
				component: <PDFIconDownload appParams={appParams} type="QFR" />,
				getPropsFn: (row, groupedRow) => {
					return {
						documents: row.documents,
						row: row
					};
				},
				displayLimitation: "web",
				explicitHide: TEMP_HIDE_DOCS || !isPPL,
				headerClassName: tabStyles.dailyHeader + ' ' + tabStyles.columnRight,
			},
			{
				headerKey: 'Watchlist',
				type: 'component',
				viewRestriction: 'table',
				component: <WatchlistButton appParams={appParams} watchlist={watchlist} editWatchlist={editWatchlist}></WatchlistButton>,
				getPropsFn: (row, groupedRow) => {
					return {
						fundName: groupedRow.display,
						fundIdentifier: groupedRow.fund.clientCode,
						isin: row.clientCode
					};
				},
				displayLimitation: "web",
				headerClassName: tabStyles.dailyHeader + ' ' + tabStyles.watchListColumn
			}
		];

		if (csvDownload) {
			return filterColumnsCSV(columns, isPPL);
		}

		return removeKeyWhenFalse(columns, "tooltip");
	}

	render() {
		let { funds, toggleFund, toggleAllFunds, isLoading, groupedRows, toggleShareClass, toggleShareClassPerformance, appParams, disclaimers, infiniteScroll, execInfiniteScroll, watchlist, editWatchlist } = this.props;
		const isPPL = appParams.productrange.toUpperCase() === "PPL";

		return (
			<div className={styles.tabDailyPrices}>
				<ExplorerTabContent {...this.props} isPPL={isPPL} columns={this.getColumns(isPPL)} />
				<FundExplorerFooter {...this.props} />
				{!isPrint(appParams) && <Disclaimer appParams={appParams} disclaimer={disclaimers["daily_prices_disclaimer"]} />}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/client/components/FundExplorerTabs/FundExplorerDailyPricesTab.tsx